import React from "react";
import { ArrowPathIcon, XCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";

export default function CallErrorPage({ error, onRetry, onClose }) {

  
  return (
    <div
      id="modal-backdrop"
    
      className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50"
    >
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 space-y-6 relative animate-slide-up">
        <button 
          onClick={onClose} 
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 transition"
        >
          <XMarkIcon className="w-6 h-6" />
        </button>

        <div className="flex justify-center">
          <div className="p-4 bg-red-100/70 rounded-full animate-pulse">
            <XCircleIcon className="w-14 h-14 text-red-600" />
          </div>
        </div>

    
        <div className="text-center space-y-3">
          <h2 className="text-2xl font-bold text-gray-900">Connection Lost</h2>
          <p className="text-gray-600">{error || "Oops! We lost the connection to your call."}</p>
        </div>


        <div className="flex flex-col space-y-4">
          <button
            onClick={onRetry}
            className="w-full flex items-center justify-center gap-2 px-6 py-3.5 bg-[#19818C]  text-white rounded-xl transition-all 
            duration-300 hover:scale-[1.03] active:scale-95 shadow-md"
          >
            <ArrowPathIcon className="w-5 h-5" />
            <span className="font-semibold">Reconnect Now</span>
          </button>
          
          <div
            onClick={onClose}
            className="w-full px-6 py-3.5 text-gray-700 hover:text-gray-900 text-center font-semibold rounded-xl transition-all
            duration-300 hover:bg-gray-100 active:bg-gray-200 cursor-pointer"
          >
            Back to Bristu Talk
          </div>
        </div>

        <p className="text-center text-sm text-gray-500">
          Still having trouble? {" "}
          <a href="/contact" className="text-red-600 hover:underline">Contact Support</a>
        </p>

        
        <p className="text-center text-sm text-gray-500 mt-4">
          Need immediate assistance? Call us at <a href="tel:+1234567890" className="text-[#19818C] hover:underline">+91 000009000 </a>
          or email us at <a href="mailto:support@bristutalk.com" className="text-[#19818C] hover:underline">support@bristutalk.com</a>
        </p>
      </div>
    </div>
  );
}
